import { gql } from '@apollo/client';

// Add / edit (billable, quantity) / remove a service line on the order being viewed.
export const INSERT_SERVICE = gql`
    mutation InsertOrderService($object: services_insert_input!) {
        insert_services_one(object: $object) {
            service_id
        }
    }
`;

export const UPDATE_SERVICE = gql`
    mutation UpdateOrderService($service_id: uuid!, $set: services_set_input!) {
        update_services_by_pk(pk_columns: { service_id: $service_id }, _set: $set) {
            service_id
        }
    }
`;

export const DELETE_SERVICE = gql`
    mutation DeleteOrderService($service_id: uuid!) {
        delete_services_by_pk(service_id: $service_id) {
            service_id
        }
    }
`;

/**
 * A parent's existing service clones, never its split children. The next -S{n} suffix derives from the max suffix
 * in their order_numbers; read network-only so a stale cache can't resurrect a lower max.
 */
export const SERVICE_CLONES_BY_ORIGINAL = gql`
    query ServiceClonesByOriginal($original_order_id: uuid!) {
        orders(
            where: {
                original_order_id: { _eq: $original_order_id }
                order_type: { _eq: "service" }
                split_seq: { _is_null: true }
            }
        ) {
            order_id
            order_number
        }
    }
`;

// The root parent's number/PO, used to name a new clone as a flat sibling. The viewed order only
// carries original_order_id (a uuid), so splitting a child must look up the parent's display names.
export const ORDER_NAMES_BY_ID = gql`
    query OrderNamesById($order_id: uuid!) {
        orders(where: { order_id: { _eq: $order_id } }) {
            order_id
            order_number
            po_number
        }
    }
`;

// One atomic split (option b — copy-then-delete): insert the service clone (with only the selected
// service lines nested — items stay on the parent) AND delete those selected service rows from the
// parent. Net effect = the selected services move to the clone.
export const SPLIT_SERVICE_ORDER = gql`
    mutation SplitServiceOrder($order: orders_insert_input!, $service_ids: [uuid!]!) {
        clone: insert_orders_one(object: $order) {
            order_id
            order_number
            po_number
        }
        delete_services(where: { service_id: { _in: $service_ids } }) {
            affected_rows
        }
    }
`;
